import { A, Br, Button, Div, not, H2, P, UL, LI, Span, reactive } from 'alkali'
import { track } from 'components/tracking/track'
import './Explanation.scss'
import { hasScreeningAccess } from 'model/Screening'
import { hasExtractAccess, switchToScreeningTab, switchToExtractTab } from '../studies/StudiesTabs'
import { activeTab } from 'model/StudyCollection'
import { studyDetailsPane } from '../studies/StudyDetailsPane'
import { 
    quitAutoPromptTourNoUser, 
    quitAutoPromptTour, 
    removeContents,
    quickAnalysisMap,
    tourRunner,
	controlUX,
	renderText,
} from './Tour'

let buildQuestion = document.querySelector('.ask-question')

class Explanation extends Div('.welcome-explanation') {
	created(properties) {
		properties.content = [...properties.content]
		properties.display = true
	}
}

const searchResultsText = [
	[P("The Search Results tab shows all of the studies DocAnalytics has found from searching the universe of literature and trials based on your search terms. DocAnalytics searches across:"), Br,
	UL([
		LI('PubMed/Medline'),
		LI('Trials Registries (clinicaltrials.gov, EU Trials, WHO ICTRP)'),
		LI('DocCongress, a selection of congress abstracts'),
		LI('CORD 19, a COVID-19 literature database'),
		LI('MedRxiv')
	]),
	P('Some of these studies have data that is pre-configured and available for analysis. Studies without pre-configured data can be reviewed and manually entered, if desired.'), 
	P('DocAnalytics pre-configured data comes from:'), Br,
	UL([
		LI('Trials Registries, any posted study results (Clinicaltrials.gov, EU Trials)'),
		LI("DrEvidence's database of curated and quality controlled data from ~30,000 studies")
	])],

	[P('To open studies to review available data, click the ➤')],

	[P('Use the filter panel to adjust the conditions, treatments, and outcomes included. Additionally, study filters can specify study design, source, publication date, or be used to find your own collections of studies.')],

	[P(Span([P('Navigate to the'), P({style: 'font-weight: bold' }, hasScreeningAccess.to(screeningAccess => screeningAccess ? ' Screening ' : hasExtractAccess.to(extractAccess => extractAccess ? ' Extract ' : ' Analyzable '))) , P(hasScreeningAccess.to(screeningAccess => screeningAccess ? 'tab to review studies to be included in the analysis.' : hasExtractAccess.to(extractAccess => extractAccess ? 'tab to continue' : 'tab to continue')))]))]
]

export let searchResultsTextIndex = reactive(0)
const SearchResults = Explanation.with('.complete-workflow-search', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('metaReportTour')
				quitAutoPromptTour('MetaReport')
				removeContents()
				document.querySelector('.search-results').classList.remove('report-styling')
				return
			}
		})
		document.querySelector('.complete-workflow-search .top-container').append(new Div('.explanatory-text', [renderText(searchResultsText, searchResultsTextIndex)]))
		document.querySelector('.search-results .next-button').classList.remove('hidden')
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2('Search Results'),
			A('.close', [' '], {
				onclick() {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.classList.remove('welcome-styling')
					if (document.querySelector('.highlight-circle')) {
						document.querySelector('.study-head-item.study-expander').removeChild(document.querySelector('.highlight-circle'))
					}
					removeContents()
					return
				},
			}),
		]),
	]),
	Div('.bottom-container', [
		Button('.back-button', ['Back'], {
			onclick(event) {
				document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))
				
                if (searchResultsTextIndex == 0) {
					removeContents()
					return tourRunner(quickAnalysisMap, 0)
				} else {
					searchResultsTextIndex.put(searchResultsTextIndex.valueOf() - 1)
					if (searchResultsTextIndex == 1) {
						controlUX('.study-head-item.study-expander', '.highlight-circle.carrot', 5000, 'append')
					} else if (searchResultsTextIndex == 2) {
						controlUX('.search-results .filter-pane', 'glow', 8000)
					}
				}
                document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(searchResultsText, searchResultsTextIndex)]))
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
		Button('.next-button', ['Next'], {
			async onclick(event) {
                document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))

                if (searchResultsTextIndex == 3) {
                    removeContents()
					if (hasScreeningAccess.valueOf()) {
						switchToScreeningTab()
						tourRunner(completeWorkflowMap, 1) 
					} else if (hasExtractAccess.valueOf()) {
						switchToExtractTab()
						tourRunner(completeWorkflowMap, 2)
					} else {
						activeTab.put('analyzable')
						studyDetailsPane.hide()
						tourRunner(quickAnalysisMap, 2) // Analyzable tab
					}
                } else {
					searchResultsTextIndex.put(searchResultsTextIndex.valueOf() + 1)
					if (searchResultsTextIndex == 1) {
						document.querySelector('.complete-workflow-search .back-button').classList.remove('hidden')
						controlUX('.study-head-item.study-expander', '.highlight-circle.carrot', 5000, 'append')
					} else if (searchResultsTextIndex == 2) {
						controlUX('.search-results .filter-pane', 'glow', 8000)
					} else if (searchResultsTextIndex == 3) {
						let nextTab = hasScreeningAccess.valueOf() 
							? '#screening p' : hasExtractAccess.valueOf() 
								? '#extract p' : '#selected p'
						controlUX(nextTab, 'add-highlight', 2000)
						document.querySelector(nextTab).onclick = () => {
							if (this.onclick === null) return
							removeContents()
                    		hasScreeningAccess.valueOf()
                        		? tourRunner(completeWorkflowMap, 1) 
                        		: hasExtractAccess.valueOf()
                            		? tourRunner(completeWorkflowMap, 2)
                            		: tourRunner(quickAnalysisMap, 2) 
							this.onlick = null
							return
						}
					}

                    document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(searchResultsText, searchResultsTextIndex)]))
                    event.stopPropagation()
                    event.preventDefault()
                    return
                }
			},
		}),
	]),  
])

const screeningText = [
    [P('The Screening tab is where you review the study list and chose which studies fit the criteria for your specific research question. This list will dynamically update as you include or exclude studies. Included studies will  appear on the extract and analyzable tabs to review in the next step.'), Br, P('The screening view shows an annoted abstract, supplies full text links, and provides additional information on the study design, related publications and the overall match to your research question. ')],

    [P(Span([P('To exclude a study from your analysis, click the '), P({style: 'font-weight: bold'}, ' Exclude '), P('button and choose the reason for exclusion. Excluding studies from your analysis will have them removed from the Screening tab.')]))],

    [P(Span([P('Marking a study as '), P({style: 'font-weight: bold'}, ' uncertain '), P('will not remove the study from the Screening tab and will allow you to revisit the study later.')]))],

    [P(Span([P('Choosing to'), P({style: 'font-weight: bold'}, ' include '), P('studies in your analysis will remove them from the Screening tab and place them either in the Analyzable tab if the study has pre-configured data or the Extract tab if the study does not have pre-configured data. To continue, include the first 5 studies in the study list.')])), Br, Span([P('Then click the'), P({style: 'font-weight: bold'}, hasExtractAccess.to(extractAccess => extractAccess ? ' Extract ' : ' Analyzable ')), P('tab to continue.')])],
]

export let screeningTextIndex = reactive(0)
const Screening = Explanation.with('.complete-workflow-screening', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('metaReportTour')
				quitAutoPromptTour('MetaReport')
				removeContents()
				document.querySelector('.search-results').classList.remove('report-styling')
				return
			}
		})
		document.querySelector('.complete-workflow-screening .top-container').append(new Div('.explanatory-text', [renderText(screeningText, screeningTextIndex)]))
		document.querySelector('.search-results .next-button').classList.remove('hidden')
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2('Screening'),
			A('.close', [' '], {
				onclick() {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					return
				},
			}),
		]),
	]),
	Div('.bottom-container', [
		Button('.back-button', ['Back'], {
			onclick(event) {
				document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))

				if (screeningTextIndex == 0) {
					activeTab.put('sources')
					studyDetailsPane.hide()
					// Navigate to SearchResults
					removeContents()
					tourRunner(completeWorkflowMap, 0)
					return
				} else {
					screeningTextIndex.put(screeningTextIndex.valueOf() - 1)
					if (document.querySelector('.study-select-option')) {
						if (screeningTextIndex == 1) {
							controlUX('.study-select-option .reject-study', 'glow', 5000)
						} else if (screeningTextIndex == 2) {
							controlUX('.study-select-option .maybe-study', 'glow', 5000)
						}
					}
				}

                document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(screeningText, screeningTextIndex)]))
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
		Button('.next-button', ['Next'], {
			async onclick(event) {
                document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))

                if (screeningTextIndex == 3) {
                    removeContents()
					if (hasExtractAccess.valueOf()) {
						switchToExtractTab()
						tourRunner(completeWorkflowMap, 2)
					} else {
						activeTab.put('analyzable')
						studyDetailsPane.hide()
						tourRunner(quickAnalysisMap, 2) // Analyzable
					}
					return
                } else {
					screeningTextIndex.put(screeningTextIndex.valueOf() + 1)
					if (document.querySelector('.study-select-option')) {
						if (screeningTextIndex == 1) {
							controlUX('.study-select-option .reject-study', 'glow', 5000)
						} else if (screeningTextIndex == 2) {
							controlUX('.study-select-option .maybe-study', 'glow', 5000)
						} else if (screeningTextIndex == 3) {
							controlUX('.study-select-option .include-study', 'glow', 5000)
							let nextTab = hasExtractAccess.valueOf() ? '#extract p' : '#selected p'
							controlUX(nextTab, 'add-highlight', 2000)
							document.querySelector(nextTab).onclick = () => {
								if (this.onclick === null) return
								removeContents()
                    			hasExtractAccess.valueOf() ? tourRunner(completeWorkflowMap, 2) : tourRunner(quickAnalysisMap, 2)
								this.onclick = null
								return
							}
						}
					} else if (screeningTextIndex == 3) {
						controlUX('#extract p', 'add-highlight', 2000)
					}
                }

				document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(screeningText, screeningTextIndex)]))
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
	]),  
])

const extractText = [
    [P('The Extract tab is where you edit or add additional data from published studies.')],

    [P('Review the suggested information that is auto-filled in the form and determine what needs to be added or updated.')],

    [P('Input data by typing into the fields or by clicking into the field and clicking on a highlighted value in the abstract'),Br, Span([P('Find more detailed information on'), A({href: 'https://confluence.doctorevidence.com/display/shareit/67502217/KQI66c55447d30b4a269c6b13ff583df466WMY', target: "_blank"}, ' Rapid Extract '), P('in the help content.')])],

    [P('The data of interest may not be present in the abstract. Click one of the links to open the full text. ')],

    [P(Span([P('When complete, click'), P({style: 'font-weight: bold'}, ' Submit Extraction. '), P("This data will be available immediately to use for analysis and will be added to DocAnalytic's database of pre-configured data.")])), Br, 
    Span([P('This study will now appear in the Analyzable tab. Click the'), P({style: 'font-weight: bold'}, ' Analyzable '), P('tab to continue.')])]
]

export let extractTextIndex = reactive(0)
const Extract = Explanation.with('.complete-workflow-extract', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('metaReportTour')
				quitAutoPromptTour('MetaReport')
				removeContents()
				document.querySelector('.search-results').classList.remove('report-styling')
				return
			}
		})
		document.querySelector('.complete-workflow-extract .top-container').append(new Div('.explanatory-text', [renderText(extractText, extractTextIndex)]))
		document.querySelector('.search-results .next-button').classList.remove('hidden')
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2('Extract'),
			A('.close', [' '], {
				onclick() {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					return
				},
			}),
		]),
	]),
	Div('.bottom-container', [
		Button('.back-button', ['Back'], {
			async onclick(event) {
				document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))

                if (extractTextIndex == 0) {
                    removeContents()
                    if (hasScreeningAccess.valueOf()) {
						switchToScreeningTab()
						tourRunner(completeWorkflowMap, 1)
						setTimeout(() => controlUX('.study-select-option .include-study', 'glow', 5000), 500)
						
					} else {
						activeTab.put('sources')
						studyDetailsPane.hide()
						tourRunner(completeWorkflowMap, 0)
					}
					return
                } else {
					extractTextIndex.put(extractTextIndex.valueOf() - 1)
					if (extractTextIndex == 3) {
						controlUX('.view-abstract .src-link', 'glow', 6000, 'each')
					}
				}

                document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(extractText, extractTextIndex)]))
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
		Button('.next-button', ['Next'], {
			onclick(event) {
                document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))
                if (extractTextIndex == 4) {
					activeTab.put('analyzable')
					studyDetailsPane.hide()
                    removeContents()
                    tourRunner(quickAnalysisMap, 2)
					return
                } else {
					extractTextIndex.put(extractTextIndex.valueOf() + 1)
					if (extractTextIndex == 3) {
						// Highlight full text links
						controlUX('.view-abstract .src-link', 'glow', 6000, 'each')
					} else if (extractTextIndex == 4) {
						controlUX('#selected p', 'add-highlight', 2000)
						document.querySelector('#selected p').onclick = () => {
							if (this.onclick === null) return
							document.querySelector('.complete-workflow-extract .next-button').classList.remove('hidden')
							removeContents()
							tourRunner(quickAnalysisMap, 2)
							this.onclick = null
							return
						}
					}
				}
				document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(extractText, extractTextIndex)]))
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
	]),  
])



// NOTE: Remaining components of Complete Workflow tour (Analyzable and Run analysis) are shared with Tour.ts 

export const completeWorkflowMap = [
    {
        target: '.search-results',
        element: SearchResults
    },
    {
        target: '.search-results',
        element: Screening
    },
    {
        target: '.search-results',
        element: Extract
    }
]